import { Injectable } from "@angular/core";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { ISystemControlLookupService } from "../ISystemControlLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class SystemControlLookupService
  extends BaseLookupService<string, CubiqTS.SystemControlImpl>
  implements ISystemControlLookupService
{
  constructor() {
    super(CubiqTS.SystemControlImpl);
  }

  getItemKey(item: CubiqTS.SystemControlImpl): string {
    let sc = item as CubiqTS.SystemControlImpl;
    return CubiqTS.SystemControlSubType[sc.systemControlSubType];
  }

  setSystemStatus(systemControl: CubiqTS.SystemControlImpl): void {}
}
